import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, OutlinedInput } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { RADIUS } from '../../../theme/muiTheme';

export default function EmissionFactorToolbar({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <OutlinedInput
      fullWidth
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t('emissionFactor.searchPlaceholder')}
      inputProps={{ 'aria-label': t('emissionFactor.searchPlaceholder') }}
      startAdornment={(
        <InputAdornment position="start">
          <SearchRoundedIcon fontSize="small" color="disabled" />
        </InputAdornment>
      )}
      sx={{ bgcolor: 'background.paper', borderRadius: `${RADIUS.control}px` }}
    />
  );
}
